import { useTranslation } from "react-i18next";
import InputCustom from "../../../components/InputComponents/InputCustom";
import { Input } from "semantic-ui-react";
import QRCode from "qrcode.react";
import InputCopy from "../../../components/CopyComponent/InputCopy";

const VipBankPayment = ({
  morePaymentList,
  setBankPaymentSelected,
  bankPaymentSelected,
  onDataChange,
}) => {
  const { t } = useTranslation();
  const i18n = (key) => t(`deposit.${key}`);
  const i18n_common = (key) => t(`common.${key}`);

  return (
    <>
      <section>
        <span className="text-transaction-text dark:text-base-light-white">
          {i18n("selectChannel")}
        </span>
        <select
          onChange={(e) => {
            const selectedBankName = e.target.value;
            const selectedItem = morePaymentList.find(
              (item) => item.bank_name === selectedBankName
            );
            localStorage.setItem(
              "bankPaymentSelected",
              JSON.stringify(selectedItem)
            );
            JSON.parse(localStorage.getItem("bankPaymentSelected"));
            setBankPaymentSelected(selectedItem);
          }}
          className="w-full !text-base-light-dark dark:!text-base-light-white bg-base-light-white dark:!bg-base-light-black border dark:border-base-light-dark rounded-[5px] py-[10px] px-[12px] outline-0 text-transaction-text"
        >
          <option value="" disabled selected>
            {i18n_common("pleaseSelect")}
          </option>
          {morePaymentList?.map((list) => {
            return <option value={list.bank_name}>{list.bank_name}</option>;
          })}
        </select>
      </section>
      {bankPaymentSelected?.bank_name && (
        <>
          <section>
            <span className="text-transaction-text dark:text-base-light-white">
              {i18n("bank_account")}
            </span>
            <Input disabled size="large" className="w-full">
              <input
                className="!text-base-light-dark dark:!text-base-light-white bg-base-light-white dark:!bg-base-light-black border dark:border-base-light-dark"
                type="text"
                value={bankPaymentSelected?.bank_acc}
              />
            </Input>
          </section>
          <section>
            <span className="text-transaction-text dark:text-base-light-white">
              {i18n("bank_number")}
            </span>
            <Input disabled size="large" className="w-full">
              <input
                className="!text-base-light-dark dark:!text-base-light-white bg-base-light-white dark:!bg-base-light-black border dark:border-base-light-dark"
                type="text"
                value={bankPaymentSelected?.bank_num}
              />
            </Input>
            {/* <InputCopy copyLink={bankPaymentSelected?.bank_num} /> */}
            {/* <div className="bg-hover-transaction-card dark:bg-base-light-dark rounded-b-[5px] py-[20px] flex items-center justify-center">
              <div className="bg-base-light-white dark:bg-base-light-dark p-[5px] text-center">
                <QRCode //銀行帳號的QRCode
                  value={bankPaymentSelected?.bank_num}
                  renderAs="canvas"
                />
              </div>
            </div> */}
          </section>
        </>
      )}
    </>
  );
};

export default VipBankPayment;
